module.exports = __webpack_public_path__ + "static/media/shutterstock_55184455_ppcc.84053c60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/shutterstock_55184455_ppcc.jpg
// module id = 1786
// module chunks = 1